import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { AdformLandingPagesResponseSchema } from '../shared/schemas/adformLandingPages.js';

export type {
  AdformCampaignLandingPagesType,
  AdformLandingPageType,
  AdformLandingPagesResponseType,
} from '../shared/schemas/adformLandingPages.js';

export const getAdformLandingPages = defaultClient.query({
  url: 'omni-trafficking/v1/external-data/adform/landing-pages/' as const,
  method: 'GET',
  responseSchema: AdformLandingPagesResponseSchema,
  processResponse(data) {
    return data?.data?.items;
  },
  querySchema: z.object({
    integrationId: z.string(),
    campaignId: z.array(z.string()),
  }),
  snakeCaseQueryParams: true,
});
